import { trackContactClicks } from "./src/helpers/analytics"

export { wrapPageElement } from "./src/helpers/pageLanguage"

export const onClientEntry = () => {
  trackContactClicks()
}
